module.exports = __webpack_public_path__ + "static/media/logo-animalis.8e6a77e6.png";